import thumbnail from './pyramidchart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.pyramidchart.title',
  id: 'pyramidchart',
  thumbnail,
  icon: 'fa-chart-pyramid',
  categories: ['categories.correlations', 'categories.proportions'],
  description: 'global.section.chartselection.pyramidchart.description',
  code: '',
  tutorial: '',
};
